import React, { Component } from 'react';
import { Map, TileLayer, Marker, Pane, Tooltip } from 'react-leaflet';

import { stopIcon } from '../../../components/leaflet/StopIcon';

export class StopsMap extends Component {
    constructor(props) {
        super(props);

        const bounds = [];
        if (undefined !== props.stops && 0 < props.stops.length) {
            for (let idx in props.stops) {
                bounds.push(props.stops[idx].position);
            }
        }
        else {
            bounds.push([90, 180]);
            bounds.push([-90, -180]);
        }

        this.state = {
            bounds: bounds
        };
    }

    renderMarker(stop, idx) {
        if (stop.hidden) {
            return null;
        }

        return (
            <Marker key={`marker-${idx}`}
                position={stop.position !== undefined ? stop.position : [0, 0]}
                icon={stopIcon}
                draggable={true}
                onDragend={(e) => this.props.onDragend(stop.id, e)}
                onClick={undefined === this.props.onClickEditStop ? null : () => this.props.onClickEditStop(stop.id)} >
                <Tooltip><span>{stop.name} ({stop.code})</span></Tooltip>
            </Marker>
        );
    }

    renderMarkers(stops) {
        if (undefined === stops) {
            return null;
        }

        return (
            <div>{stops.map((stop, idx) => this.renderMarker(stop, idx))}</div>
        );
    }

    render() {
        const { bounds } = this.state;
        const { stops, filter } = this.props;
        
        let filteredStops = stops;
        if (filter !== undefined) {
            const filters = filter.split('|');
            filteredStops = stops.filter(s => {
                for (let i = 0; i < filters.length; i++) {
                    let key = filters[i];
                    if (s[key] === false) {
                        return false;
                    }
                }
                return true;
            });
        }

        return (
            <Map className="map-container"
                bounds={bounds}
                perfectCanvas={true}
                onClick={undefined === this.props.onClickCreateStop ? null : (e) => this.props.onClickCreateStop(e)} >
                <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Pane>{this.renderMarkers(filteredStops)}</Pane>
            </Map>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/StopsMap.js